import styled from '@emotion/styled';

export const MenuMainNavigation = styled.div`
  transition: color 0.2s ease-in-out;

  & .nav-item img {
    transition: color 0.2s ease-in-out;
    color: white;
  }

  & .nav-item {
    transition: color 0.2s ease-in-out;
    height: 40px;
    color: ${({ theme }) => theme.colors.AlphaWhite};

    &.active,
    &:hover,
    &:active {
      color: ${({ theme }) => theme.colors.SurfaceWhite};
    }

    &.disabled {
      color: ${({ theme }) => theme.colors.SurfaceRomanSilver30};
    }
  }

  & .recently-added li {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
